export default __webpack_public_path__ + "static/media/twitterLogo.b6a56a79.webp";